export enum Languages {
	NL = 'nl',
	EN = 'en'
}

export enum DocumentLanguage {
	NL = 'nl-NL',
	EN = 'en-US'
}